//
//
//
//
//
//
//
//
//

export default {
  name: "viwocertificatelist",
  data() {
    return {
      list: []
    }
  },
  methods: {
    showContent(seq) {
      this.$router.push({name: 'viwocertificate', query: {seq, setting: true}})
    }
  },
  created() {
    const openid = localStorage.getItem('openid')
     const unionid = localStorage.getItem('unionid')
    this.$http.get('api/v1/wechat/' + unionid).then(async (res) => {
      //res.data = res.data.filter(item=>{
      //    return item.tp=='official' || item.role == 'ADMIN' || item.role == 'SRVP'
      //});       
      let account;
      res.data.forEach(item => {
        if (item.role === 'EXPT') {
          account = item.account
        }
      })
      if (account) {
        const response = await this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
        localStorage.setItem('userid', response.data.userid)
        localStorage.setItem('token', response.data.token)
        const header = {
          headers: {
            token: response.data.token,
            opid: response.data.userid
          }
        }
        this.$http.get('api/v1/certs/get_cert?userid=' + response.data.userid, header).then(response => {
          this.list = response.data.map(item => {
            switch (item.state) {
              case 'WAIT_AUDIT':
                item.state = '待审核'
                item.color = '#b2b2b2'
                break
              case 'OK':
                item.state = '审核通过'
                item.color = '#0bb20c'
                break
              case 'NO':
                item.state = '审核未通过'
                item.color = '#f76260'
                break
              case 'EXPIRED':
                item.state = '无效证书'
                item.color = '#f76260'
                break
              case 'BLACKED':
                item.state = '已过期，需重新认证'
                item.color = '#f76260'
                break
              default:
                item.state = '审核未通过'
                item.color = '#f76260'
            }
            return {...item}
          })
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/certificate/viwocertificatelist.vue